import React from 'react';
import { View } from 'react-native';

import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { Text } from '../../../components';
import { InformationCallout } from '../../../components/callout';
import SetupSection from '../components/SetupSection';
import SetupTextField from '../components/SetupTextField';
import SetupSwitchField from '../components/SetupSwitchField';
import { createMarketSetupDetailStyles } from './MarketSetupDetail.styles';

const MarketSetupKioskSection = ({
	marketSetup,
	isAssignedMarketSetupWorker,
	updateMarketSetup,
	handlePaymentDeviceSerialUpdate,
}) => {
	const styles = useThemedStyles(createMarketSetupDetailStyles);
	const clientLocationName = marketSetup.locationSetup?.location?.name;
	const stickyNoteHint = clientLocationName
		? `Put a sticky note on the kiosk(s) stating the client location: ${clientLocationName}`
		: 'Put a sticky note on the kiosk(s) stating the client location name.';

	return (
		<SetupSection title="Kiosk(s) setup">
			<SetupSwitchField
				label="Put a sticky note on the kiosk(s)"
				value={marketSetup.stickyNote}
				onChange={value => updateMarketSetup({ stickyNote: value })}
				hint={stickyNoteHint}
				required={true}
			/>

			<Text style={styles.sectionLabel}>Initial Sentry steps</Text>
			<SetupSwitchField
				label="Assign the kiosk (comm device) to the market in Sentry"
				value={marketSetup.assignKiosk}
				onChange={value => updateMarketSetup({ assignKiosk: value })}
				hint="You can do this here in the information section."
			/>

			{!isAssignedMarketSetupWorker && <InformationCallout text="We store the credit card reader serial number on the kiosk comm device. If the reader changes in real life, update Sentry so we keep track of it." />}

			{
				(marketSetup.commDevices || []).map(device => (
					<View key={device.id} style={styles.deviceCard}>
						<Text style={styles.deviceName}>{device.deviceId}</Text>
						<SetupTextField
							label="Credit card reader"
							value={marketSetup.paymentDevicesSerialNo ? marketSetup.paymentDevicesSerialNo[device.id] : ''}
							field="paymentDeviceSerialNo"
							onConfirm={({ paymentDeviceSerialNo }) => handlePaymentDeviceSerialUpdate(device, paymentDeviceSerialNo)}
							placeholder="Record serial number"
							hint="If no credit card reader is installed, install one and record the serial number."
						/>
					</View>
				))
			}

			<Text style={styles.sectionLabel}>Test transactions</Text>
			<SetupSwitchField
				label="Do a test transaction on the Windcave device and confirm receipt"
				value={marketSetup.testNayaxTransaction}
				onChange={value => updateMarketSetup({ testNayaxTransaction: value })}
				hint="Payline portal for Windcave"
				required={true}
			/>
			<SetupSwitchField
				label="Do a test phone transaction on the Windcave device and confirm receipt"
				value={marketSetup.phoneTransactionTest}
				onChange={value => updateMarketSetup({ phoneTransactionTest: value })}
				hint="Payline portal for Windcave"
				required={true}
			/>
			<SetupSwitchField
				label="Verify the sales transactions in Sentry"
				value={marketSetup.verifySalesTransactionInSentry}
				onChange={value => updateMarketSetup({ verifySalesTransactionInSentry: value })}
				hint="These sales should always appear in Sentry."
				required={true}
			/>
		</SetupSection>
	);
};

export default MarketSetupKioskSection;
